import { render } from "./auth-base-signup-success.vue?vue&type=template&id=03cdbd64&scoped=true&ts=true"
import script from "./auth-base-signup-success.vue?vue&type=script&lang=ts"
export * from "./auth-base-signup-success.vue?vue&type=script&lang=ts"

import "./auth-base-signup-success.vue?vue&type=style&index=0&id=03cdbd64&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cdbd64"]])

export default __exports__